import { translations } from 'locales/i18n';

export enum CurveType {
  LIQUID = 'liquid',
  GAS = 'gas',
  WATER = 'water',
}

export enum CurveLabels {
  PREDICTED_LIQUID = 'PREDICTED_LIQUID',
  PREDICTED_GAS = 'PREDICTED_GAS',
  PREDICTED_WATER = 'PREDICTED_WATER',
  CH4_CO2E = 'CH4_CO2E',
  CO2 = 'CO2',
  N2O_CO2E = 'N2O_CO2E',
}

export enum WidgetCurveType {
  PRODUCTION = 'production',
  EMISSIONS = 'emissions',
  PREDICT = 'predict',
}

export enum EmissionCurvesType {
  CH4CO2E = 'ch4Co2e',
  CO2 = 'co2',
  N2OCO2E = 'n2oCo2e',
}

export enum EmissionDownloadCurves {
  CH4_CO2E = 'CH4_CO2E',
  CO2 = 'CO2',
  N2O_CO2E = 'N2O_CO2E',
}

export const EMISSION_OPTIONS = [EmissionCurvesType.CH4CO2E, EmissionCurvesType.CO2, EmissionCurvesType.N2OCO2E];

export enum ProductionTypeValue {
  CUM = 'cum',
  RATE = 'rate',
}

export enum P_Curve {
  P10 = 'P10',
  P30 = 'P30',
  P50 = 'P50',
  P70 = 'P70',
  P90 = 'P90',
}

export const AGREGATED_EMISSIONS_KEYS = [
  `${EmissionCurvesType.CH4CO2E}_planned`,
  `${EmissionCurvesType.N2OCO2E}_planned`,
  `${EmissionCurvesType.CO2}_planned`,
];

export const AGREGATED_ERRORS_EMISSIONS_KEYS = [
  `${EmissionCurvesType.CH4CO2E}_planned_${P_Curve.P10}`,
  `${EmissionCurvesType.CH4CO2E}_planned_${P_Curve.P30}`,
  `${EmissionCurvesType.CH4CO2E}_planned_${P_Curve.P50}`,
  `${EmissionCurvesType.CH4CO2E}_planned_${P_Curve.P70}`,
  `${EmissionCurvesType.CH4CO2E}_planned_${P_Curve.P90}`,
  `${EmissionCurvesType.N2OCO2E}_planned_${P_Curve.P10}`,
  `${EmissionCurvesType.N2OCO2E}_planned_${P_Curve.P30}`,
  `${EmissionCurvesType.N2OCO2E}_planned_${P_Curve.P50}`,
  `${EmissionCurvesType.N2OCO2E}_planned_${P_Curve.P70}`,
  `${EmissionCurvesType.N2OCO2E}_planned_${P_Curve.P90}`,
  `${EmissionCurvesType.CO2}_planned_${P_Curve.P10}`,
  `${EmissionCurvesType.CO2}_planned_${P_Curve.P30}`,
  `${EmissionCurvesType.CO2}_planned_${P_Curve.P50}`,
  `${EmissionCurvesType.CO2}_planned_${P_Curve.P70}`,
  `${EmissionCurvesType.CO2}_planned_${P_Curve.P90}`,
];
export const ALL_AGREGATED_EMISSIONS_KEYS = [...AGREGATED_EMISSIONS_KEYS, ...AGREGATED_ERRORS_EMISSIONS_KEYS];

export type TWidgetLegendItemLabel =
  | typeof translations.WIDGET.EMISSIONS_CURVES
  | typeof translations.WIDGET.PRODUCTION_CURVES;

export enum EWellCurvesTooltip {
  BOE = 'BOE',
  TON = 'TON',
  BOE_PER_DAY = 'BOE_PER_DAY',
}

export interface LegendItemProps {
  label: string;
  isSolidLine: boolean;
  color: string;
  translation?: string;
}
